<!-- 表格资料下载详情 -->
<template>
  <div class="list5d">
    <p class="news-tltle">{{ data.name }}</p>
    <div class="news-info">
      <!-- <span class="writer">作者：{{ data.author }}</span> -->
      <span class="time">发布时间：{{ data.create_time | dateFormat }}</span>
      <span class="click">点击数：{{ data.click || 0 }}</span>
    </div>

    <div class="new-content" v-html="data.introduce_content"></div>
    <div class="file-list" v-if="fileList && fileList[0] != ''">
      <p>附件:</p>
      <ul>
        <li v-for="(item, index) in fileList" :key="index">
          <img src="./../../assets/90.png" alt="文件" @click="open(item)" />
          <span @click="open(item)">{{ item.split("/").pop() }}</span>
        </li>
      </ul>
    </div>
    <div
      class="prev pagination"
      v-if="data.pre != '没有了'"
      @click="fetchData1(data.pre.id)"
    >
      <div class="fl">
        <span class="btns">上一篇：</span>
        <span
          class="page-title"
          v-if="data.pre && data.pre.name != undefined"
          >{{ data.pre.name }}</span
        >
      </div>
      <div class="fr hidden-sm-and-down">
        <img src="./../../assets/17.png" alt="时钟" />
        <span class="date" v-if="data.pre && data.pre.create_time != undefined">
          {{ data.pre.create_time | dateFormat }}
        </span>
      </div>
    </div>

    <div class="prev pagination pagination1" v-if="data.pre == '没有了'">
      <div class="fl">
        <span class="btns">上一篇：</span>
        <span class="page-title">没有了</span>
      </div>
    </div>

    <div
      class="next pagination"
      v-if="data.next != '没有了'"
      @click="fetchData1(data.next.id)"
    >
      <div class="fl">
        <span class="btns">下一篇：</span>
        <span
          class="page-title"
          v-if="data.next && data.next.name != undefined"
          >{{ data.next.name }}</span
        >
      </div>
      <div class="fr hidden-sm-and-down">
        <img src="./../../assets/17.png" alt="时钟" />
        <span
          class="date"
          v-if="data.next && data.next.create_time != undefined"
        >
          {{ data.next.create_time | dateFormat }}
        </span>
      </div>
    </div>

    <div class="next pagination pagination1" v-if="data.next == '没有了'">
      <div class="fl">
        <span class="btns">下一篇：</span>
        <span class="page-title">没有了</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getDataDetail } from "@/api/home";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      data: {},
      fileList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open(val) {
      window.open(val, "_blank");
    },
    fetchData() {
      let params = {
        id: this.$route.query.id,
        type: 2,
      };
      getDataDetail(params).then((response) => {
        this.data = response.data;
        let list = response.data.file.split(",");
        this.fileList = list;
      });
    },
    fetchData1(ids) {
      let params = {
        id: ids,
        type: 2,
      };
      getDataDetail(params).then((response) => {
        this.data = response.data;
        let list = response.data.file.split(",");
        this.fileList = list;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="scss">
.new-content {
  img {
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
}
</style>
<style lang="scss" scoped>
.list5d {
  padding-top: 45px;
  padding-bottom: 100px;
  .news-tltle {
    font-size: 23px;
    text-align: center;
    color: #035bb2;
    margin-bottom: 20px;
  }
  .news-info {
    font-size: 14px;
    color: #989898;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 85px;
    span {
      margin-right: 20px;
    }
  }
  .new-content {
    color: #333333;
    font-size: 16px;
    line-height: 44px;
  }
  .file-list {
    margin-top: 15px;
    p {
      font-size: 18px;
      color: red;
    }
    ul {
      width: 100%;
      margin-top: 8px;
      li {
        display: flex;
        align-items: center;
        img {
          display: inline-block;
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
        span {
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  .pagination {
    height: 50px;
    line-height: 50px;
    background-color: #f4f4f4;
    color: #323232;
    padding-left: 25px;
    padding-right: 20px;
    cursor: pointer;
    .fl {
      height: 50px;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      .btns {
        font-size: 16px;
        color: #045aaf;
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }
      .page-title {
        font-size: 16px;
        color: #333333;
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }
    }
    .fr {
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .date {
        font-size: 12px;
        color: #313131;
      }
    }
  }
  .prev {
    margin-top: 40px;
    margin-bottom: 8px;
  }
  .pagination1 {
    cursor: default;
  }
}
</style>
